import {useEffect, useId, useState} from "react";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {GradeToString} from "../students/list";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {CurrencyFormat} from "../../../components/techaran/money";

interface studentInterface {
    id: number,
    name: string,
    class: string,
    grade: number,
    selected: boolean,
}

export const AdminsPresignupPickOldStudentsModal = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
}) => {
    const [level,setLevel] = useState('pick' as 'pick'|'save');
    const [list, setList] = useState<studentInterface[]>([]);
    const fetchList = () => {
        setLoaded(false);
        PostJSON(
            Apis.server + '/core/admins/presignup/old-students',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: studentInterface[] | null,
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            fetchList();
            setLevel('pick');
            setSms(true);
            setApprove(true);
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const [search, setSearch] = useState('');
    useEffect(() => {
        const lvl = level;
        const ld = loaded;
        if(!ld || lvl !== 'pick')
            return;
        const filter = search.toUpperCase();
        const lst = document.querySelector('.reports--select-employee-buttons78');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            const v = b.innerHTML.toUpperCase();
            if (v.indexOf(filter) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const [loaded, setLoaded] = useState(false);
    const isAllChecked = () => {
        const lst = [...list];
        let isAllChecked = true;
        lst.forEach(e => {
            if (!e.selected)
                isAllChecked = false;
        });
        return isAllChecked;
    };
    const [sms,setSms] = useState(true);
    const [approve,setApprove] = useState(true);
    const saveChanges = () => {
        const lst = [...list];
        const _sms = sms;
        const _approve = approve;
        let finalList:number[] = [];
        lst.forEach(e=>{
           if(e.selected)
               finalList.push(e.id);
        });
        if(finalList.length < 1){
            ShowSnackbar(
                'لطفا حداقل یک دانش‌آموز را انتخاب نمایید.',
                'باشه',
                5000,
            );
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/pick-old-students',
            {
                students:JSON.stringify(finalList),
                approve:_approve ? '1' : '0',
                sms:_approve ? (_sms ? '1' : '0') : '0', // do not send sms if not approved
            },
            true,
            (d: {
                result: string,
                reason: string,
                done:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    "تعداد " + CurrencyFormat(d.done) + " دانش‌آموز به لیست افزوده شد.",
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>انتخاب دانش‌آموزان از سال جاری</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    {
                        loaded ?
                            (
                                level === 'pick' ?
                                    <div className="reports--select-employee">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <label>انتخاب دانش‌آموزان</label>
                                            <button className="btn-pay" onClick={() => {
                                                const lst = [...list];
                                                if (lst.findIndex((e) => e.selected) < 0) {
                                                    ShowSnackbar('لطفا حداقل یک دانش‌آموز را انتخاب کنید.', 'باشه', 5000);
                                                    return;
                                                }
                                                setLevel('save');
                                            }}>
                                                <b>ادامه ثبت‌نام</b>
                                            </button>
                                        </div>
                                        <div className="pick-device-search" id={"search-presignup-students-4D"}>
                                            <button><SearchIcon/></button>
                                            <input type="text"
                                                   value={search}
                                                   onChange={e => setSearch(e.currentTarget.value)}
                                                   onBlur={() => (document.querySelector('#search-presignup-students-4D') as HTMLDivElement).classList.remove('active')}
                                                   onFocus={() => (document.querySelector('#search-presignup-students-4D') as HTMLDivElement).classList.add('active')}
                                                   className="f-roboto"
                                                   placeholder={"جستجو براساس نام یا کلاس..."}
                                            />
                                        </div>
                                        {
                                            search.trim() === '' && list.length > 0 ?
                                                <>
                                                    <hr/>
                                                    <button
                                                        className={"techaran-checkbox" + (isAllChecked() ? ' active' : '')}
                                                        onClick={() => {
                                                            const isChecked = isAllChecked();
                                                            if (isChecked)
                                                                setList(v => {
                                                                    let x = [...v];
                                                                    x.forEach(r => {
                                                                        r.selected = false;
                                                                    });
                                                                    return x;
                                                                });
                                                            else
                                                                setList(v => {
                                                                    let x = [...v];
                                                                    x.forEach(r => {
                                                                        r.selected = true;
                                                                    });
                                                                    return x;
                                                                });
                                                        }}>
                                                        <i><CheckIcon/></i>
                                                        <span>انتخاب همه</span>
                                                    </button>
                                                    <hr/>
                                                </> : null
                                        }
                                        <div className="reports--select-employee-buttons78">
                                            {
                                                list.map((e, i) =>
                                                        <button key={"KJds83jns89ssFg32d" + i}
                                                                className={"techaran-checkbox" + (e.selected ? ' active' : '')}
                                                                onClick={() => setList(v => {
                                                                    let x = [...v];
                                                                    const id = x.findIndex(r => r.id === e.id);
                                                                    x[id].selected = !x[id].selected;
                                                                    return x;
                                                                })}>
                                                            <i>
                                                                <CheckIcon/>
                                                            </i>
                                                            <span>
                                            {e.name}
                                                                <em>{(e.class === '' ? 'بدون کلاس - ' : `${e.class} - `) + GradeToString(e.grade)}</em>
                                        </span>
                                                        </button>
                                                )
                                            }
                                        </div>
                                    </div> :
                                    <>
                                        <div className="add-student">
                                            <span style={{display:'block',fontWeight:400,color:'#0a53be',margin:'20px 0'}}>
                                                تعداد
                                                {(()=>{
                                                    const x = [...list];
                                                    let i = 0;
                                                    x.forEach(e=>{
                                                        if(e.selected)
                                                            i++;
                                                    });
                                                    return " " + CurrencyFormat(i) + " ";
                                                })()}
                                                دانش‌آموز انتخاب شده است.
                                            </span>
                                            <button className={"techaran-checkbox" + (approve ? ' active':'')} onClick={()=>setApprove(v=>!v)}>
                                                <i><CheckIcon/></i>
                                                <span>تایید اولیه
                                                        <em>دانش‌آموز قادر خواهد بود اقدام به پرداخت پیش‌پرداخت نماید.</em>
                                                    </span>
                                            </button>
                                            {
                                                approve ?
                                                    <button className={"techaran-checkbox" + (sms ? ' active':'')} onClick={()=>setSms(v=>!v)}>
                                                        <i><CheckIcon/></i>
                                                        <span>ارسال پیامک
                                                            <em>ارسال پیامک اطلاع رسانی به والدین.</em>
                                                        </span>
                                                    </button> : null
                                            }
                                            <div className="d-flex justify-content-end align-items-center" style={{gap:5,marginTop:10}}>
                                                <button className="cancel-button" onClick={props.closeHandler}>
                                                    <b>انصراف</b>
                                                </button>
                                                <button className="btn-pay" onClick={saveChanges}>
                                                    <b>ذخیره اطلاعات</b>
                                                </button>
                                            </div>
                                        </div>
                                    </>
                            ) :
                            <div className="d-flex justify-content-center align-items-center"
                                 style={{padding: '70px 0'}}>
                                <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                            </div>
                    }
                </div>
            </div>
        </>
    );
};